import theme from '@optimus-web/theme';

export * from '@mews-ui/theme';
export * from './components';
export default theme;
